import { render, staticRenderFns } from "./FilterSidebarSizesGroupItem.vue?vue&type=template&id=47859d7e&scoped=true"
import script from "./FilterSidebarSizesGroupItem.vue?vue&type=script&lang=js"
export * from "./FilterSidebarSizesGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47859d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47859d7e')) {
      api.createRecord('47859d7e', component.options)
    } else {
      api.reload('47859d7e', component.options)
    }
    module.hot.accept("./FilterSidebarSizesGroupItem.vue?vue&type=template&id=47859d7e&scoped=true", function () {
      api.rerender('47859d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarSizesGroupItem.vue"
export default component.exports